export interface Profile {
    id: number;
    vc_uuid: string;
    vc_uuid_user: string;
    vc_username: string;
    vc_name: string;
    vc_last_name: string;
    tx_biography: string;
    vc_portfolio: string;
    tx_trajectory: string;
    tx_proyectos_destacados: string;
    experience_unit: 'months' | 'years';
    intereses_participacion: string;
    colectivo_perteneciente: string;
    experience_value: number;
    vc_photo_profile: string;
    vc_phone: string;
    vc_email: string;
    vc_web?: string;
    vc_link_paging_offical?: string;
    profile_type: string;
    profile_id: number;
    json_area: string;
    json_sub_area: string;
    json_roles: string;
    json_service: string;
    created_at: string;
    updated_at: string;
    b_ocultarcontacto: false;
    b_ocultarredes: false;
    b_ocultarubicacion: false;
    full_name: string;
    profile_url: string;
    starirs: number;
    coordenadax: string;
    coordenaday: string;
    calificacion: number;
    total_followers: number;
    total_following: number;
    profile: ProfileDetail;
    social_network: SocialNetwork;
    geolocalization: Geolocalization;
    artisan: Artisan;
    featured: Featured;
    area: Array<Area>;
    sub_area: Array<SubArea>;
    subcampo: Array<Subcampo>;
    roles: Array<Rol>;
    services: Array<Service>;
    rating: [];
    admin: boolean;
    characterization: string;
    country: string;

    //data colectivo
    vc_name_collective: string;
    collective_type: string;
    creation_date: string;
    detalle_espacios: string;
    espacios_propios: boolean;
    formato_actividades: string;
    incluye_discapacidad: boolean;
    miembros_activos: string;
    mision_vision: string;
    numero_integrantes: number;
    oferta_discapacidad: string;
    politicas_inclusion: string;
    tipo_discapacidad: string;
    disability_type: string;
    proyectos_desarrollados: string;
    grupo_poblacional: string;
    aliados: string;
    territory: Territory;
    

    //data publico
    mecanismos_participacion: string;
    insturmentos_apoyo: string;
    recursos_cultura: boolean;
    tipo_apoyo: string;
    otro_tipo_apoyo: string;
    estrategias_accesibilidad: string;
    ajustes_apoyos: string;
    interes_fortalecer: boolean;
    public_profile: PublicProfile;
    investigacion_academica: InvestigacionAcademica;

    //data espacios
    accesibilidad_inclusion: AccesibilidadInclusion;
    identidad_institucional: IdentidadInstitucional;
}
export interface SocialNetwork {
    facebook?: string;
    instagram?: string;
    twitter?: string;
    tiktok?: string;
    linkedin?: string;
    youtube?: string;
    vc_facebook?: string;
    vc_instagram?: string;
    vc_twitter?: string;
    vc_tiktok?: string;
    vc_linkedin?: string;
    vc_youtube?: string;
}
export interface ProfileDetail {
    id: number;
    vc_artist_type: string;
    created_at: string;
    updated_at: string;
}
export interface Geolocalization {
    id: number;
    i_fk_id_artist: number;
    vc_xaxis: string;
    vc_yaxis: string;
    vc_neighbourhood: string;
    vc_locality: string;
    vc_upz: string;
    vc_custom_address: string;
    created_at: string;
    updated_at: string;
}
export interface Featured {
    id?: number;
    i_fk_id_artist?: number;
    vc_youtube: string;
    vc_vimeo: string;
    vc_behance: string;
    vc_pinterest: string;
    vc_spotify: string;
    vc_speaker: string;
    vc_soundcloud: string;
    created_at?: string;
    updated_at?: string;
}
export interface Area {
    id: number;
    i_fk_id_artist: number;
    i_fk_id_area: number;
    area_name: string;
    created_at: string;
    updated_at: string;
    parameter_detail: string;
}
export interface SubArea {
    id: number;
    i_fk_id_artist: number;
    i_fk_id_sub_area: number;
    subarea_name: string;
    created_at: string;
    updated_at: string;
    parameter_detail: string;
}

export interface Subcampo {
    id: number;
    i_fk_id_artist: number;
    i_fk_id_subcampo: number;
    subcampo_name: string;
    created_at: string;
    updated_at: string;
    parameter_detail: string;
}
export interface Rol {
    id: number;
    i_fk_id_artist: number;
    i_fk_id_rol: string;
    created_at: string;
    updated_at: string;
    parameter_detail: string;
}
export interface Service {
    id: number;
    i_fk_id_artist: number;
    i_fk_id_service: number;
    created_at: string;
    updated_at: string;
    parameter_detail: ParameterDetail;
}
export interface ParameterDetail {
    id: number;
    vc_nombre: string;
    vc_additional_information: string;
    i_fk_id_parameter: number;
    i_fk_id_parameter_detail: number;
    created_at: string;
    updated_at: string;
}

export interface Artisan {
    id: number;
    espacio_detalle_artisan: string;
    espacio_publico_artisan: boolean;
    i_fk_id_artist: number;
    localidad_artisan: number;
    oficio_artisan: string;
    sector_comercio_artisan: string;
    tecnica_artisan: string;
    created_at: string;
    updated_at: string;
}

export interface Territory {
    id: number;
    detalle: string;
    territorio_id: string;
    i_fk_id_collective: number;
    created_at: string;
    updated_at: string;
}

export interface PublicProfile {
    id: number;
    i_fk_id_business: number;
    funcion_cultural: string;
    programas_culturales: string;
    territorios_incidencia: string;
    poblaciones_trabajo: string;
    otro_poblacion: string;
    articulaciones_redes: string;
}

export interface AccesibilidadInclusion {
    i_pk_id: number;
    i_fk_id_espacio: number;
    estrategias_accesibilidad: 'si' | 'no' | 'en_proceso' | string;
    programas_discapacidad: string;
    educacion_inclusiva: string;
    ajustes_apoyos: string; 
    interes_fortalecer: boolean;
    created_at: string;
    updated_at: string;
}

export interface IdentidadInstitucional {
    nombre_institucion: string;
    tipo_institucion: string;
    naturaleza: string;
    nivel_educativo: string;
    otro_nivel_educativo?: string;
    anio_fundacion: number;
    acreditaciones?: string;
    oferta_formativa_cultural: boolean;
    detalle_oferta?: string;
    programas_oferta: string; 
    modalidad: string;
    duracion_valor: number;
    duracion_unidad: string;
    certificacion: boolean;
}
export interface InvestigacionAcademica {
    grupos_investigacion?: string;
    lineas_investigacion_cultural?: string;
    proyectos_investigacion_vigentes?: string;
    publicaciones?: string;
    revistas?: string;
    produccion_academica_descargable?: string;
}